import { useEffect } from 'react';
import t from 'react-translate';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { useForm, FormProvider } from 'react-hook-form';
import { useMentorRequestContext } from '../mentor-request-context';

import MentorRequestContainer from '../mentor-request-container';
import { getPlainTextFromHTML } from 'redux/actions/mentorship-program-connections';

const MESSAGE_MAX_LENGTH = 500;

const MentorAvailableStatus = () => {
  const {
    aliases,
    requests,
    sendRequest,
    setCanDiscardChanges,
    setResetForm,
  } = useMentorRequestContext();
  const validationSchema = yup.object().shape({
    message: yup.string().required(t.FORM.REQUIRED()).test(
      'max',
      t.VALIDATION.MAX_LENGTH(`${MESSAGE_MAX_LENGTH}`),
      (value: string) => getPlainTextFromHTML(value).length <= MESSAGE_MAX_LENGTH,
    ),
  });

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      message: t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.MESSAGE(aliases.mentor.downcasedSingularized),
    },
    resolver: yupResolver(validationSchema),
  });

  const { handleSubmit, formState, reset } = methods;
  const { isDirty } = formState;

  useEffect(() => {
    setCanDiscardChanges?.(!isDirty);
  }, [isDirty, setCanDiscardChanges]);

  useEffect(() => {
    setResetForm?.(() => () => {
      reset();
    });
  }, [reset, setResetForm]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(sendRequest)}>
        <MentorRequestContainer.Header />
        <MentorRequestContainer.Description />
        {requests.length > 0 && (
          requests.map((request) => (
            <MentorRequestContainer.Request
              key={request.id}
              request={request}
            />
          ))
        )}
        <MentorRequestContainer.MessageInput />
        <MentorRequestContainer.SubmitRequest />
      </form>
    </FormProvider>
  );
};

export default MentorAvailableStatus;
